import React, { useState } from 'react';

// 유튜브 영상 목록을 이 배열에 추가하세요. id는 유튜브 동영상 ID 입니다.
// 예: https://www.youtube.com/watch?v=ysz5S6PUM-U => id: 'ysz5S6PUM-U'
const videos = [
  {
    id: 'Mjj2T6ugIGQ',
    title: '1. 두고팡 무료체험 신청',
    description: '두고팡에 오신것을 환영합니다. 무료체험 신청방법을 알아보세요.'
  },
  {
    id: 'YAn_t5RyT2s',
    title: '2. 두고팡 관리자 페이지 학생등록',
    description: '무료체험 신청 후, 관리자페이지에 들어오셨다면 학생등록부터 시작해주세요.'
  },
  {
    id: 'WAEi3MFLDSY',
    title: '3. 두고팡 수준별 스케쥴교재 생성',
    description: '학생 수준에 맞게 스케쥴교재를 생성하고 관리해보세요.'
  },
  {
    id: 'iZh51i1o5C8',
    title: '4. 두고팡 교재 워크시트, 문제은행 출력',
    description: '복습, 테스트 등 수업에 활용할 문제자료를 직접 출력해보세요.'
  },
  {
    id: 'ZIR5h-YIUTA',
    title: '5. 두고팡 성적분석 활용 방법',
    description: '수업 이후, 피드백으로 활용하거나 학부모님께 성적 레포트를 자동 발송해보세요.'
  },
  {
    id: 'qwl5yFVCH9c',
    title: '6. 두고팡 학습모드시작, 학생앱 이용방법',
    description: '영상학습, 문제풀이 등 단계별 바둑학습을 지금 바로 진행해보세요.'
  },
];

const getThumbUrl = (id) => `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
const getFallbackThumbUrl = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

const VideoManual = () => {
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const closeModal = () => setSelectedVideoId(null);

  return (
    <div className="max-w-[380px] md:max-w-[900px] mx-auto mt-12 mb-20 md:mb-28">
      {/* 상단 제목/설명 */}
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-2xl md:text-4xl font-extrabold text-[#111]">영상 매뉴얼</h2>
        <p className="mt-3 text-xs md:text-base text-gray-700 leading-relaxed">
          처음 이용하시거나, 온라인 학습 운영 간 궁금한 점이 생기셨나요?
          <br className="hidden md:block" />
          두고팡이 준비한 영상 매뉴얼로 해결해 보세요!
        </p>
      </div>
      {/* 썸네일 그리드 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {videos.length === 0 && (
          <div className="text-center text-gray-500 col-span-full">등록된 영상이 없습니다.</div>
        )}
        {videos.map((video) => (
          <button
            key={video.id}
            type="button"
            className="group text-left bg-white overflow-hidden"
            onClick={() => setSelectedVideoId(video.id)}
          >
            <div className="relative">
              <img
                src={getThumbUrl(video.id)}
                alt={`${video.title} 썸네일`}
                className="w-full h-auto block"
                onError={(e) => {
                  e.currentTarget.src = getFallbackThumbUrl(video.id);
                }}
              />
              {/* Play 버튼 오버레이 */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-black/60 group-hover:bg-black/70 flex items-center justify-center">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="white" aria-hidden="true">
                    <path d="M8 5v14l11-7z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base md:text-lg font-bold text-[#333]">{video.title}</h3>
              <p className="mt-1 text-xs md:text-sm text-gray-600 leading-5 md:leading-6 min-h-[40px] md:min-h-[48px]">
                {video.description ? video.description : '\u00A0'}
              </p>
            </div>
          </button>
        ))}
      </div>

      {/* 영상 모달 */}
      {selectedVideoId && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute -top-10 right-0 text-white text-2xl hover:text-gray-300"
              onClick={closeModal}
              aria-label="닫기"
            >
              ✕
            </button>
            <div className="relative pt-[56.25%] bg-black rounded-lg overflow-hidden shadow-xl">
              <iframe
                title="video-player"
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${selectedVideoId}?autoplay=1&rel=0`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoManual;


